export default "<div class=\"card bg-1\">\n  <div class=\"card-content\">\n    {{nomeFundo}}\n  </div>\n</div>\n";